export default {
    text_1: "Položky a ceny",
    text_2: "Položky a ceny",
    text_3: "V tejto sekcii si môžeš vytvoriť vlastnú databázu položiek a ich cien, uložiť si ich do budúcna a následne si ich pri tvorbe ponuky vieš len vybrať zo zoznamu",
    text_4: "Vytvoriť novú položku",
    text_5: "Upraviť položku",
    text_6: "Vymazať položku",
    text_7: "SKU",
    text_8: "Interný názov",
    text_9: "Verejný názov",
    text_10: "Cena bez DPH",
    text_11: "Cena s DPH",

    text_12: "Určite?",
    text_13: "Naozaj chceš vymazať položku?",
    text_14: "Nie",
    text_15: "Áno",
    text_16: "Položka bola úspešne vymazaná",
    text_17: "Položka bola úspešne vytvorená",
    text_18: "Položka bola úspešne upravená",

    text_20: "Nová položka",
    text_21: "Uprava položky",
    text_22: "Interný názov položky (POVINNÉ)",
    text_23: "Interný názov slúži pre tvoju evidenciu",
    text_24: "Verejný názov položky",
    text_25: "Verejný názov budeme používať v cenovej ponuke",
    text_26: "ID / SKU",
    text_27: "Ak používaš skladové hospodárstvo, môžeš si zaznačiť ID / SKU",
    text_28: "interný Popis položky",
    text_29: "Interný popis slúži pre teba.",
    text_30: "Text",
    text_31: "verejný Popis položky",
    text_32: "Verejný popis budeme používať v cenovej ponuke",
    text_33: "Cena položky",

    text_34: "Nastaviť cenu s DPH",
    text_35: "Nastaviť cenu s ",
    text_36: "% DPH",
    text_37: "Cena položky s dph",
    text_38: "Uložiť položku",

    text_39: "ID / SKU / Názov položky",

    text_40: "Základné informácie",
    text_41: "Cena a fakturácia",
    text_42: "Typ ceny",
    text_43: "Cena za hodinovú sadzbu",
    text_44: "Cenový rozsah od - do",
    text_45: "Vlastná cena",
    text_46: "Hodinový rozsah od - do",
    text_47: "Počet hodín",
    text_48: "Sadzba",
    text_49: "Cena od",
    text_50: "Cena do",
    text_51: "Jednotka",
    text_52: "Počet",
    text_53: "Počet hodín od",
    text_54: "Počet hodín do",
    text_55: "Cena položky (bez DPH)",
};
